
<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">

  
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">User Notifications</h4>
          </div>

          <div class="row align-items-center m-1">
            <div class="col-md-6 col-12 d-flex align-items-center">
              <label class="d-flex align-items-center m-1 w-15">
                <div
                  class="font-medium-1 font-weight-bold line-height-1 mb-25 text-center"
                >
                  Show :
                </div>
              </label>
              <label class="d-flex align-items-center m-1 w-50">
                <select
                  class="form-control mx-25 w-50"
                  [(ngModel)]="basicSelectedOption"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>

            <!-- Third Column - Search -->
            <div
              class="col-md-6 col-12 d-flex justify-content-end align-items-center"
            >
              <label class="d-flex align-items-center m-1 w-100">
                <label class="d-flex align-items-center m-1 w-15">
                  <div
                    class="font-medium-1 font-weight-bold line-height-1 mb-25 text-center"
                  >
                    Search
                  </div>
                </label>

                <div class="input-group">
                  <input
                    #searchInput
                    type="text"
                    class="form-control"
                    (keyup)="filterUpdate($event)"
                    (search)="filterUpdate($event)"
                    placeholder="{{
                      'MENU.DASHBOARD.SEARCH' | translate
                    }}"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btnn"
                      type="button"
                      (click)="filterUpdate($event)"
                    >
                      <i class="fa fa-search"></i>
                      <!-- FontAwesome search icon -->
                    </button>
                  </div>
                </div>
              </label>
            </div>
          </div>
  
          <ngx-datatable
            [rows]="notifications"
            [rowHeight]="78" class="bootstrap core-bootstrap bg-white"
            [limit]="basicSelectedOption" [headerHeight]="60" [footerHeight]="30"
            [scrollbarH]="true" [columnMode]="'force'" 
          >
            <ngx-datatable-column name="Id" prop="id" [width]="120">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <small
                    class="font-small-3 font-weight-bold line-height-1 mb-25"
                  >
                    {{ row.id }}
                  </small>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
            name="Full Name"
            prop="full name"
            [flexGrow]="50"
          >
            <ng-template ngx-datatable-cell-template let-row="row">
              <div
              class="d-flex align-items-center"

              >
                <img
                  [src]="
                    getFirstImage(row.additionalProperties?.user)
                  "
                  alt="Image"
                  class="avatar mr-1"
                  width="40"
                  height="40"
                  style="object-fit: cover; border-radius: 50%"
                />
                <small
                  class="font-medium-1 font-weight-bold line-height-1 mb-25 text-start goalngo-hover"
                  style="text-wrap: wrap; word-break: break-word"
                >
                  {{ row.additionalProperties?.user?.firstName }}
                  {{ row.additionalProperties?.user?.lastName }}

                </small>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
          name="Role "
          prop="role"
          [width]="100"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            <div class="cell-line-height">
              <p
                class="font-medium-1 font-weight-bold line-height-1 mb-25 text-center "
              >
                {{ row.additionalProperties?.user?.role }}
              </p>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
        name="Age"
        prop="number_of_notifications"
        [width]="100"
      >
        <ng-template ngx-datatable-cell-template let-row="row">
          <div class="cell-line-height">
            <p class="font-medium-1 font-weight-bold line-height-1 mb-25">
              {{ row.additionalProperties?.user?.age }}
            </p>
          </div>
        </ng-template>
      </ngx-datatable-column>




            <ngx-datatable-column
              name="Notifications Type "
              prop="notification_type"
              [width]="100"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p
                    class="font-medium-1 font-weight-bold line-height-1 mb-25 text-center badge badge-light-primary"
                  >
                    {{ row.type.split("_").join(" ") || "----" }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>

            
  
            <ngx-datatable-column
              name="Number of Notifications"
              prop="number_of_notifications"
              [width]="100"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="cell-line-height">
                  <p class="font-medium-1 font-weight-bold line-height-1 mb-25">
                    {{ row.count }}
                  </p>
                </div>
              </ng-template>
            </ngx-datatable-column>
  

  
            <ngx-datatable-column name="{{ 'MENU.DASHBOARD.ACTIONS' | translate }}" [width]="80" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <div ngbDropdown container="body">
                    <a
                      ngbDropdownToggle
                      href="javascript:void(0);"
                      class="hide-arrow"
                      id="dropdownBrowserState"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i
                        data-feather="more-vertical"
                        class="text-primary cursor-pointer mr-50"
                      ></i>
                    </a>
                    <div
                      ngbDropdownMenu
                      class="dropdown-menu-right"
                      aria-labelledby="dropdownBrowserState"
                    >
                      <a
                        [routerLink]="['/profile', row.additionalProperties?.user?.id]"
                        ngbDropdownItem
                        class="d-flex align-items-center"
                        ><i data-feather="eye" class="mr-50"></i>User Profile</a
                      >
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </section>
    </div>
  </div>
  